<template>
  <div class="dynamic-content">
    <h1 class="page-title">How Participation-Based Benefits Work</h1>
    
    <p class="desc-text section-spacing">Participation-based benefits are granted based on user activity and engagement.</p>

    <div class="content-section">
      <h3 class="sub-title">These benefits:</h3>
      <ul class="bullet-list">
        <li>• Are not purchased</li>
        <li>• Have no cash value</li>
        <li>• Are not transferable</li>
        <li>• Are not redeemable for money</li>
      </ul>
    </div>

    <div class="content-section">
      <h2 class="section-title">How Benefits Are Earned</h2>
      <p class="desc-text">Benefits may be granted through actions such as:</p>
      <ul class="bullet-list">
        <li>• Completing transactions</li>
        <li>• Maintaining good account standing</li>
        <li>• Participating in platform activities</li>
      </ul>
    </div>

    <div class="content-section">
      <h2 class="section-title">What Benefits Include</h2>
      <p class="desc-text">Participation-based benefits may include:</p>
      <ul class="bullet-list">
        <li>• Service fee offsets</li>
        <li>• Visibility privileges</li>
        <li>• Optional feature access</li>
      </ul>
    </div>

    <div class="content-section">
      <h2 class="section-title">Important Clarification</h2>
      <p class="desc-text">Participation-based benefits do not represent financial rewards or income.</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ParticipationBenefits'
}
</script>

<style scoped>
@import './shared-info-styles.css';
</style>
